import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import { ArticleService } from './services/article.services';
import { CAtegorieService } from './services/categorie.services';
import { Meta, Title } from '@angular/platform-browser';
import { LoadingService } from './services/loading.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  showLoading: boolean = true;
  firstLoad: boolean = true;
  isHomePage: boolean = false;
  ListArticles:any[]=[];
  constructor(private router: Router, private loadingService: LoadingService , private cdr: ChangeDetectorRef, private articleservice:ArticleService ,
    private categoryService: CAtegorieService ,  private titleService: Title,  // 👈 Ajout du service Title
    private metaService: Meta ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        window.scrollTo(0, 0);
      }
    });
    this.router.events.subscribe(() => {
      this.isHomePage = this.router.url === '/home'; // Vérifie si l'URL est la page d'accueil
    });
  }
  title = 'ecom-adora';
  ngOnInit(): void {
    this.loadingService.show();


    this.load().then(() => {

      this.loadingService.hide();
      console.log("Loader désactivé");


      this.cdr.detectChanges();
      console.log("Change detection forcée !");
    });

    setTimeout(() => {
      this.showLoading = false;
      this.firstLoad = false;
    }, 3000);


  }


  async load(): Promise<void> {
    try {
      const requestBody = {
        nbre_page: 1,
        nbre_article: 42,
        order_by: "id",
        search: "",
      };

      console.log("🟡 Chargement des articles...");

      const res: any = await lastValueFrom(this.articleservice.getArticlesPaginated(requestBody));

      console.log("🟢 Articles reçus :", res);
      this.articleservice.setArticles(res.articles || res);

      const promo: any = await lastValueFrom(this.articleservice.getPromoArticles(requestBody));
      console.log("🟢 Articles reçus :", promo);
      this.articleservice.setArticle(promo.articles || promo);
    } catch (error) {
      console.error("❌ Erreur lors du chargement des articles", error);
      throw error;
    }
  }
}
